export const INITIAL_STATE = {
  roomId: '',
  longitude: '',
  latitude: '',
};
